export default "__VITE_ASSET__5nMaHtdI__"